const ADMIN_KEY_STORAGE = "adminApiKey";

/**
 * localStorageに保存されたAdmin APIキーを取得する。
 * DevToolsから: localStorage.setItem('adminApiKey', '<key>') で設定。
 */
export function getAdminApiKey(): string | null {
	try {
		return localStorage.getItem(ADMIN_KEY_STORAGE);
	} catch {
		return null;
	}
}

/**
 * Admin APIキーがlocalStorageに設定されているか確認する。
 */
export function isAdminMode(): boolean {
	return !!getAdminApiKey();
}
